import store from '../store/store';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { isEmailAddress } from 'owa-mail-option-common';
import { select } from 'satcheljs/lib/legacy';
var arrayEquals = require('array-equal');
export default select({
    optionState: function () { return store; },
    mailboxJunkEmailConfiguration: function () { return getMailboxJunkEmailConfiguration(); },
})(function isSafeMailingListsOptionDirty(state) {
    var _a = state, optionState = _a.optionState, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration;
    if (!mailboxJunkEmailConfiguration || !optionState.safeMailingLists) {
        return false;
    }
    return !arrayEquals(optionState.safeMailingLists, mailboxJunkEmailConfiguration.TrustedRecipientsAndDomains.filter(function (item) {
        return isEmailAddress(item);
    }));
});
//# sourceMappingURL=isSafeMailingListsOptionDirty.js.map